// submitOrder API
import ajax from './_ajax';

const api = {};
api.getPaymentTypes = function () {
  return ajax.get('/api/order/GetPaymentTypes');
};
api.getAll = function (type) {
  return ajax.get('/api/Address/GetAll?type=' + type);
};
api.addAllAddress = function (obj) {
  return ajax.post('/api/Address/Add', obj);
};
api.editAllAddress = function (obj) {
  return ajax.post('/api/Address/Edit', obj);
};
api.deleteAllAddress = function (obj) {
  return ajax.post('/api/Address/Delete', obj);
};
api.setDefaultAllAddress = function (obj) {
  return ajax.post('/api/Address/SetDefault', obj);
};
api.getAllCountryInfo = function () {
  return ajax.get('/api/Country/GetAllCountryInfo');
};
api.preparePlaceOrder = function (obj) {
  return ajax.post('/api/OrderProcess/PreparePlaceOrder', obj);
};
api.confirmPlaceOrder = function (obj) {
  return ajax.post('/api/OrderProcess/ConfirmPlaceOrder', obj);
};
api.refreshOrderShippingPrice = function (obj) {
  return ajax.post('/api/OrderProcess/RefreshOrderShippingPrice', obj);
};
api.getShippmingMethods = function () {
  return ajax.get('/api/Order/GetShippmingMethods');
};
export default api;



// WEBPACK FOOTER //
// ./src/api/submitOrderApi.js